import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('VIRAL');
export const FETCH_ALL = ActionType.RSAA('FETCH_ALL');

export const ActionTypes = {
  VIRAL_IS_ENABLED: 'VIRAL_IS_ENABLED',
  VIRAL_SHOW_ITEM_DETAIL: 'VIRAL_SHOW_ITEM_DETAIL',
  VIRAL_HIDE_ITEM_DETAIL: 'VIRAL_HIDE_ITEM_DETAIL',
  VIRAL_PLAY_ITEM: 'VIRAL_PLAY_ITEM',
};
